import service from './service';
import { UrlBuilder } from './url-builder';

export const list = async (recordDate, page, pageSize) => {
  const response = await service.get(
    `/logbooks/all/entries?recordDate=${recordDate}&page=${page}&pageSize=${pageSize}`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

// export const listByAdmin = async (recordDate, page, pageSize, companyFilter) => {
//   const response = await service.get(
//     `/admin/logbooks/all/entries?recordDate=${recordDate}&page=${page}&pageSize=${pageSize}&companyId=${companyFilter}`
//   );

//   if (response.status === 200) {
//     const data = response.data;

//     return data;
//   }

//   return undefined;
// };

const listByAdmin = async (page, pageSize, companyFilter) => {
  const builder = new UrlBuilder(`/admin/logbooks/all/entries`);

  // builder.add('recordDate', recordDate);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  builder.add('companyId', companyFilter);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};
const listByAdminForReport = async () => {
  const builder = new UrlBuilder(`/admin/logbooks/all/entries`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};

export const listAllByCompany = async (companyId, filter) => {
  if (!companyId) return [];

  const response = await service.get(
    `/companies/${companyId}/logbooks/all/entries?fromDate=${filter.fromDate}&toDate=${filter.toDate}&mode=ALL`
  );

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByCompany = async (companyId, filter, page, pageSize) => {
  if (!companyId) return [];

  const builder = new UrlBuilder(`/companies/${companyId}/logbooks/all/entries`);
  builder.add('geofenceId', filter.geofenceId);
  builder.add('fromDate', filter.fromDate);
  builder.add('toDate', filter.toDate);
  builder.add('name', filter.name);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByCompanyReport = async (companyId) => {
  const builder = new UrlBuilder(`/companies/${companyId}/logbooks/all/entries`);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const filterLogRecordList = async (geofenceId, filter, page, pageSize) => {
  if (!geofenceId) return [];

  const builder = new UrlBuilder(`/logbooks/${geofenceId}/entries`);
  builder.add('fromDate', filter.fromDate);
  builder.add('toDate', filter.toDate);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByPartner = async (partnerId, filter, page, pageSize) => {
  if (!partnerId) return { items: 0, length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/partners/${partnerId}/logbooks/all/entries`);
  builder.add('companyId', filter.companyId);
  builder.add('fromDate', filter.fromDate);
  builder.add('toDate', filter.toDate);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByPartnerReport = async (partnerId) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/logbooks/all/entries`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const selfRecords = async (partnerId, page, pageSize) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/logbooks/all/entries`);
  // /partners/{partnerId}/logbooks/all/entries

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const selfRecordsOwner = async (page, pageSize) => {
  const builder = new UrlBuilder(`/users/self/logbooks/all/entries`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const selfRecordsOwnerReport = async () => {
  const builder = new UrlBuilder(`/users/self/logbooks/all/entries`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const selfRecordsReport = async (partnerId) => {
  const builder = new UrlBuilder(`/partners/${partnerId}/logbooks/all/entries`);

  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const countByPartner = async (partnerId, { companyId }, filter) => {
  if (!partnerId) return { items: 0, length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/partners/${partnerId}/logbooks/all/entries/count`);
  // builder.add('fromDate', filter.fromDate ?? DateUtils.today());
  // builder.add('toDate', filter.toDate ?? DateUtils.today());
  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const countByAdmin = async ({ companyId }) => {
  const builder = new UrlBuilder(`/admin/logbooks/all/entries/count`);
  builder.add('companyId', companyId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const countByCompany = async (companyId, filter) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/companies/${companyId}/logbooks/all/entries/count`);
  // builder.add('fromDate', filter.fromDate ?? DateUtils.today());
  // builder.add('toDate', filter.toDate ?? DateUtils.today());

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const listByParent = async (parentId, filter, page, pageSize) => {
  if (!parentId) return { items: 0, length: 0, page: 0, pageSize: 10 };

  const builder = new UrlBuilder(`/parents/${parentId}/logbooks/all/entries`);
  builder.add('companyId', filter.companyId);
  builder.add('fromDate', filter.fromDate);
  builder.add('toDate', filter.toDate);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const countByParent = async (parentId, filter, page, pageSize) => {
  if (!parentId) return 0;

  const builder = new UrlBuilder(`/parents/${parentId}/logbooks/all/entries/count`);
  builder.add('companyId', filter.companyId);
  builder.add('fromDate', filter.fromDate);
  builder.add('toDate', filter.toDate);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByManager = async (premiseId, page, pageSize) => {
  const builder = new UrlBuilder(`/manager/logbook/premise/${premiseId}`);
  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const listByManagerForReport = async (premiseId) => {
  const builder = new UrlBuilder(`/manager/logbook/premise/${premiseId}`);
  builder.add('mode', 'ALL');

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  list,
  listByCompany,
  listAllByCompany,
  listByPartner,
  listByParent,
  countByPartner,
  countByParent,
  filterLogRecordList,
  selfRecords,
  countByAdmin,
  listByAdmin,
  listByCompanyReport,
  selfRecordsReport,
  listByPartnerReport,
  listByManagerForReport,
  listByAdminForReport,
  selfRecordsOwner,
  selfRecordsOwnerReport,
};
